// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + ({"96":"vendors","117":"vendor-msal"}[chunkId] || chunkId) + "." + {"96":"1c08f67aa3458f7aa0e3","117":"d0d157b7584131b81809","343":"10b06cf0d7546508bbdc","512":"6e30c5a7eb296b08fef9","906":"6cc8f73065e2b69b2bfb","975":"b1d34c25308b8c9d819e","992":"ec3e92900d65aef506d4"}[chunkId] + ".js";
};